module.exports = __webpack_public_path__ + "img/Frankie_Pucci.df0f02f4.png";